import { LegalPage } from './LegalPage'
import { termsHtml } from './termsContent'

export const TermsPage = () => <LegalPage html={termsHtml} />

export default TermsPage
